import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import {
  Loader,
  LoaderWrapper
} from '../components/page-loader/styled-components.js'
import PageView from '../gtm/page-view.jsx'

export const Route = createRootRouteWithContext()({
  component: RouterWrapper
})

function RouterWrapper() {
  const { auth } = Route.useRouteContext()
  const isLoadingLogin = auth?.isLoadingLogin

  return (
    <div>
      <PageView />
      {isLoadingLogin ? (
        <LoaderWrapper>
          <Loader className="loader" />
        </LoaderWrapper>
      ) : null}
      <div hidden={isLoadingLogin}>
        <Outlet />
      </div>
      <TanStackRouterDevtools />
    </div>
  )
}
